import React from 'react'
import injectSheet from 'react-jss'
import { Row, Col } from 'react-flexbox-grid'
import moment from 'moment'
import DownloadButton from './downloadButton/index.jsx'
import iCalEvent from 'icalevent'

import calendar from '../img/callendar@2x.png'
import web from '../img/web@2x.png'
import mail from '../img/mail@2x.png'

const styles = {
  root: {
    maxWidth: '1170px',
    margin: '3% auto',
    background: 'white',
    borderRadius: '4px',
    padding: '3% 0'
  },
  aboutEvent: {
    width: '90%',
    margin: '0 auto',
    borderRadius: '4px',
    textAlign: 'center',
    padding: '2% 0',
    textAlign: 'left'
  },
  mainTitle: {
    fontSize: '25px',
    textAlign: 'center'
  },
  eventDescription: {
    textAlign: 'left',
    margin: '2% auto',
    width: '90%',
    color: '#616161',
    fontSize: '18px',
    lineHeight: '23px'
  },
  eventImgContainer: {
    padding: '2% 0'
  },
  ingTitle: {
    width: '100%',
    height: '100%'
  },
  buttonContainer: {
    maxWidth: '1170px',
    margin: '0 auto',
    marginBottom: '3%'
  },
  link: {
    textDecoration: 'none',
    color: 'white'
  },
  button: {
    background: '#d2af21',
    borderRadius: '4px'
  },
  buttonRow: {
    background: '#F2B818',
    height: '100%',
    padding: '8px 0',
    borderRadius: '3px',
      '&:hover': {
        cursor: 'pointer'
      }
  },
  img: {
    margin: '5%'
  },
  title: {
    display: 'inline-block',
    marginRight: '1%'
  },
  eventAdress: {
    display: 'inline-block'
  },
  date: {
    marginBottom: '2%'
  },
  eventImg: {
    textAlign: 'left'
  },
  addToCalendar: {
    background: '#F2B818',
    color: 'white',
    border: 'none',
    height: '100%',
    width: '100%',
      '&:hover': {
        cursor: 'pointer'
      }
  },
  addToCalendarTitle: {
    textAlign: 'left',
  }
}

class EventInformation extends React.Component {

  render() {
    const { classes, currentEvent, gotoUrl } = this.props
    if(!currentEvent) {
      gotoUrl('location')
      return null
    }
    const event = new iCalEvent({
      offset: 0,
      start: currentEvent.start,
      end: currentEvent.start,
      summary: currentEvent.title,
      location: currentEvent.address
    });

    const title = 
      <Row middle='md'>
        <Col md={3} mdOffset={1}><img src={calendar} /></Col>
        <Col md={8} className={classes.addToCalendarTitle}>Add to calendar</Col>
      </Row>
    return(
      <div>
        <div className={classes.root}>
          <div>
            <h1 className={classes.mainTitle}>{currentEvent.title}</h1>
            <div
            className={classes.eventDescription}
            dangerouslySetInnerHTML={{__html: currentEvent.description}} />
            <div className={classes.aboutEvent}>
              <h2>{currentEvent.venue}</h2>
              <div>{currentEvent.address ? <div><h3 className={classes.title}>Address:</h3><div className={classes.eventAdress}>{currentEvent.address}</div></div> : <div></div>}</div>
              <div className={classes.date}><h3 className={classes.title}>Date:</h3>{moment(currentEvent.start).format('dddd[,] MMMM Do YYYY')}</div>
              <div className={classes.eventImg}>{currentEvent.photo_url  ? <img src={currentEvent.photo_url} className={classes.imgTitle} /> : <div></div>}</div>
            </div>
          </div>
        </div>
        <Row between="md" className={classes.buttonContainer}>
          <Col md={3} className={classes.button}>
            <Row middle='md' className={classes.buttonRow} onClick={() => window.location.href=currentEvent.url}>
              <Col md={2} mdOffset={1}><img src={web} className={classes.img}/></Col>
              <Col md={8} mdOffset={1}><div className={classes.link}>Event website</div></Col>
            </Row>
          </Col>
           <Col md={3} className={classes.button}>
            <Row middle='md' className={classes.buttonRow} onClick={() => window.location.href='https://mail.google.com/mail/u/0/#inbox?compose=new'}>
              <Col md={2} mdOffset={1}><img src={mail} /></Col>
              <Col md={8} mdOffset={1}><div className={classes.link}>Email event</div></Col>
            </Row>
          </Col>
          <Col md={3} className={classes.button}>
            <Row className={classes.buttonRow}>
              <Col md={12}>
                <DownloadButton
                className={classes.addToCalendar}
                downloadTitle={title}
                genFile={() => ({mime: 'text/calendar', filename: `${currentEvent.title}.ics`, contents: event.toFile()})  }
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    )
  }
}

export default injectSheet(styles)(EventInformation)



// WEBPACK FOOTER //
// ./src/components/EventInformation.jsx